<template>
  <div v-if="selectedGroup && selectedParameter" class="fullheight">
    <div v-if="selectedParameter.type === 'SELECT_ONE'" class="fullheight">
      <div class="ui input">
        <input
          v-model="search"
          type="text"
          name="search"
          placeholder="search"
        />
      </div>

      <div class="scrollable">
        <div
          v-for="(value, index) in values"
          :key="index"
          @click="select(value)"
        >
          <div :class="{ active: currentValue == value }" class="value-card">
            <div class="image">
              <img
                :src="value.picture"
              />
            </div>
            <div class="description">
              {{ value.name }}
              <span v-if="value.price > 0" class="supplement"
                >+{{ value.price }} &euro;</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedParameter.type === 'OPTION'" class="options">
      <div
        v-for="(value, index) in selectedParameter.values"
        :rel="value.name"
        :key="index"
        :class="{ active: currentValue == value }"
        class="value-card"
        @click="select(value)"
      >
        <div v-if="value.small_picture" class="image">
          <img :src="value.picture" />
        </div>
        <div class="description">
          {{ value.name }}
          <span v-if="value.price > 0" class="supplement"
            >+{{ value.price }} &euro;</span
          >
        </div>
      </div>
    </div>

    <div v-if="selectedParameter.type === 'TEXT'" class="options">
      <div class="value-card">
        <div class="content ui fluid input">
          <input
            :placeholder="selectedParameter.name + '...'"
            v-model="textValue"
            type="text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fullheight {
  height: 100%;
}

.input {
  width: 100%;
}

.scrollable {
  height: calc(100% - 35px);
  overflow-y: auto;
}

.value-card {
  position: relative;
  border: 1px solid #eee;
  display: flex;
  margin-bottom: 5px;
  cursor: pointer;
  min-height: 50px;
}

.value-card.active {
  background-color: #d7dce7;
  border: 1px solid #d7dce7;
}

.value-card .image {
  width: 50px;
  height: 50px;
}

.value-card .image img {
  background-color: #fff;
  width: 50px;
  height: 50px;
}

.value-card .description {
  font-weight: bold;
  padding: 0 5px;
}

.value-card .supplement {
  position: absolute;
  right: 10px;
  top: 5px;
  color: black;
}

.value-card.active .supplement {
  color: black;
}

.options {
  padding: 35px 0;
}
</style>

<script>
import { mapGetters } from 'vuex'

function isDef(val) {
  return val !== null && val !== undefined
}

export default {
  name: 'ValueSelector',
  props: {
    group_index: {
      type: Number,
      default: null
    },
    attribute_index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      search: '',
      textValue: ''
    }
  },
  computed: {
    ...mapGetters({
      groups: 'getGroups',
      currentShirt: 'getCurrentShirt'
    }),
    selectedGroup() {
      if (!isDef(this.group_index)) {
        return null
      }

      if (!isDef(this.groups[this.group_index])) {
        return null
      }

      return this.groups[this.group_index]
    },
    selectedParameter() {
      if (!isDef(this.selectedGroup) || !isDef(this.attribute_index)) {
        return null
      }

      if (!isDef(this.selectedGroup.parameters[this.attribute_index])) {
        return null
      }

      return this.selectedGroup.parameters[this.attribute_index]
    },
    values() {
      if (!isDef(this.selectedParameter)) {
        return []
      }

      let filter = this.selectedParameter.values

      if (this.search) {
        filter = filter.filter((v) =>
          v.name.toLowerCase().includes(this.search.toLowerCase())
        )
      }

      return filter
    },
    currentValue() {
      const group = this.selectedGroup
      if (!isDef(group)) {
        return null
      }

      const param = this.selectedParameter
      if (!isDef(param)) {
        return null
      }

      return this.currentShirt.options[group.id][param.code]
    }
  },
  watch: {
    group_index: function groupIndex() {
      this.search = ''
      if (
        this.selectedParameter.type === 'TEXT' &&
        typeof this.currentValue === 'string'
      ) {
        this.textValue = this.currentValue
      }
    },
    attribute_index: function attributeIndex() {
      this.search = ''
      if (
        this.selectedParameter.type === 'TEXT' &&
        typeof this.currentValue === 'string'
      ) {
        this.textValue = this.currentValue
      }
    },
    textValue: function updateTextValue() {
      this.select(this.textValue)
    }
  },
  methods: {
    select(value) {
      const group = this.selectedGroup
      if (!isDef(group)) {
        return
      }

      const param = this.selectedParameter
      if (!isDef(param)) {
        return
      }

      this.currentShirt.options[group.id][param.code] = value
    }
  }
}
</script>



// WEBPACK FOOTER //
// ValueSelector.vue?61be3827